export const QUOTE_FORM = 'QUOTE_FORM';
export const CLEAR_QUOTE_FORM = 'CLEAR_QUOTE_FORM';

export enum COVERME_TRAVELLER_TYPES {
  EMPTY = '',
  CANADIAN_CITIZEN = 'TRAVELLING_CANADIANS',
  EXISTING_PLAN = 'TOP_UP',
  STUDENT = 'STUDENT',
  VISITOR_TO_CANADA = 'VISITOR_TO_CANADA'
}

export enum COVERME_STUDENT_TYPES {
  EMPTY = '',
  CANADIAN_INSIDE = 'CANADIAN_INSIDE',
  CANADIAN_OUTSIDE = 'CANADIAN_OUTSIDE',
  INTERNATIONAL = 'INTERNATIONAL'
}

export enum ME_EMPLOYEE_TYPES {
  EMPTY = '',
  MANULIFE_EMPLOYEE = 'MANULIFE_EMPLOYEE',
  RESIDE_WITH_MANULIFE_EMPLOYEE = 'RESIDE_WITH_MANULIFE_EMPLOYEE',
  NOT_RESIDE_WITH_MANULIFE_EMPLOYEE = 'NOT_RESIDE_WITH_MANULIFE_EMPLOYEE'
}
export enum ME_EMPLOYEE_TYPES_API {
  MANULIFE_EMPLOYEE = 'EMPL',
  RESIDE_WITH_MANULIFE_EMPLOYEE = 'FNF_RES',
  NOT_RESIDE_WITH_MANULIFE_EMPLOYEE = 'FNF_NONRES'
}

export enum BREAKDOWN_TYPES {
  TRAVELLINGWITHINCANADA = 'TRAVELLINGWITHINCANADA',
  COMPANION = 'COMPANION',
  EMPLOYEE = 'EMPLOYEE',
  FAMILYFRIENDSRESIDING = 'FAMILYFRIENDSRESIDING',
  FAMILYFRIENDSNOTRESIDING = 'FAMILYFRIENDSNOTRESIDING'
}

export enum BREAKDOWN_TYPES_API {
  COMPANION = 'COMPANION',
  EMPLOYEE = 'EMPL',
  FAMILYFRIENDSRESIDING = 'FNF_RES',
  FAMILYFRIENDSNOTRESIDING = 'FNF_NONRES'
}

export interface QuoteFormTraveller {
  dateOfBirth?: string;
  format?: string;
  age?: number;
  tripCost?: number;
  referenceNumber?: number;
  tripBookingDate?: string;
  tripBookingDateError?: boolean;
}

export interface QuoteForm {
  departureDate?: string;
  returnDate?: string;
  applicationDate?: string;
  destination?: string;
  country?: string;
  province?: string;
  travelOutsideCanada?: string;
  multiTrip?: string;
  multiTripTemp?: string;
  returnDateMultiTrip?: string;
  familyPlans?: string;
  isFamily?: boolean;
  planCoverageDayCount?: number;
  travellerOptions?: ME_EMPLOYEE_TYPES;
  travellerType?: COVERME_TRAVELLER_TYPES;
  studentType?: COVERME_STUDENT_TYPES;
  travellerCount?: number;
  travellers?: QuoteFormTraveller[];
  departureLocation?: string;
  furthestDestination?: string;
  // CoverMe Student fields
  arrivingDate?: string;
  schoolStartDate?: string;
  schoolEndDate?: string;
  leavingDate?: string;
  coverageStartDate?: string;
  coverageEndDate?: string;
  coverageDaysGood?: boolean;
  schoolName?: string;
  schoolCity?: string;
  // VTC fields
  superVisa?: string;
  medicalCoverage?: string;
  // For StepGuard
  isComplete?: boolean;
  employeeType?: ME_EMPLOYEE_TYPES;
  employeeName?: string;
  referenceId?: string;
  destinationCountry?: string;
  destinationName?: string;
  hasUSLayover?: string;
  showInvalidPlanError?: boolean;
}

export interface QuoteFormStore {
  form?: QuoteForm;
}
